module.exports = __webpack_public_path__ + "static/media/balance_75000_100000.192668da.png";